<template>
  <div class="osmap">
    <l-map  style="height: 100%; width: 100%; z-index: 0;" :zoom="FOCUS_COORD.zoom" :center="FOCUS_COORD.center">
      <l-control-polyline-measure :options="{ showUnitControl: true }" position="bottomright"/>
      <l-tile-layer :url="url"></l-tile-layer>
       <l-circle-marker
       v-for="(marker,index) in MARKERS"
        :key="index"
        :lat-lng="[marker.latitude, marker.longitude]"
        :radius="2"
        :color="marker.color"
        @click="focusOnMarker([marker.latitude, marker.longitude]); openMarker(marker.id_dtp); "
      ></l-circle-marker>

        <l-circle
        v-for="cluster in CLUSTERS"
        :key="cluster.id"
        :lat-lng="cluster.central_point"
        :radius="cluster.circle_radius"
        :color="cluster.color"
        @click="getCluster(cluster.pk)"
      />
    </l-map><v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{SELECTED_MARKER.id_dtp}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-divider></v-divider>
                Местоположение: {{SELECTED_MARKER.location}}<br>
                Дата: {{SELECTED_MARKER.date}}<br>
                Время: {{SELECTED_MARKER.time}}<br>
                Вид ДТП: {{SELECTED_MARKER.type_dtp}}<br>
                Место: {{SELECTED_MARKER.place}}<br>
                Вид покрытия:{{SELECTED_MARKER.coating_type}}<br>
                Улица: {{SELECTED_MARKER.street}}<br>
                Дом: {{SELECTED_MARKER.house}}<br>
                Дорога: {{SELECTED_MARKER.road}}<br>
                Километр: {{SELECTED_MARKER.kilometer}}<br>
                Метр: {{SELECTED_MARKER.meter}}<br>
                <v-divider></v-divider>
                Ранено: {{SELECTED_MARKER.injured}}<br>
                Ранено детей: {{SELECTED_MARKER.injured_child}}<br>
                Погибло: {{SELECTED_MARKER.loss}}<br>
                Погибло детей: {{SELECTED_MARKER.loss_child}}<br>
<v-divider></v-divider>
                НДУ: {{SELECTED_MARKER.ndu_1}}<br>
                НДУ: {{SELECTED_MARKER.ndu_2}}<br>
                НДУ: {{SELECTED_MARKER.ndu_3}}<br>
                НДУ: {{SELECTED_MARKER.ndu_4}}<br>
                Объекты УДС на месте: {{SELECTED_MARKER.uds_inplace_1}}<br>
                Объекты УДС на месте: {{SELECTED_MARKER.uds_inplace_2}}<br>
                Объекты УДС вблизи: {{SELECTED_MARKER.uds_near_1}}<br>
                Объекты УДС вблизи: {{SELECTED_MARKER.uds_near_2}}<br>
                Объекты УДС вблизи: {{SELECTED_MARKER.uds_near_3}}<br>
                Объекты УДС вблизи: {{SELECTED_MARKER.uds_near_4}}<br>
<v-divider></v-divider>
                Освещение: {{SELECTED_MARKER.lighting}}<br>
                Состояние погоды: {{SELECTED_MARKER.weather_1}}<br>
                Состояние проезжей части: {{SELECTED_MARKER.road_condition}}<br>
                Дорога в плане: {{SELECTED_MARKER.road_in_plan}}<br>
                Профиль дороги: {{SELECTED_MARKER.road_profile}}<br>
                Вид разделительной полосы: {{SELECTED_MARKER.dividing_line_type}}<br>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    </v-dialog>
  </v-row>

  </div>
</template>

<script>
import { LMap, LTileLayer, LCircleMarker, LCircle} from "vue2-leaflet";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    LMap,
    LTileLayer,
    LCircleMarker,
    LCircle,
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      dialog: false,
      overlay: false
    };
  },
   methods: {
     ...mapActions(["GET_FOCUS_COORD","GET_SELECTED_MARKER", "GET_CLUSTER"]),
      focusOnMarker(coord) {
        this.GET_FOCUS_COORD({zoom: 14, center: coord})
      },
      openMarker(id) {
        this.GET_SELECTED_MARKER(id);
        this.overlay = !this.overlay;
        setTimeout(() => {
          this.dialog = true
        }, 1000)
      },
      getCluster(id) {
        this.GET_CLUSTER(id);
      }
    },
    computed: {
      ...mapGetters(["MARKERS","CLUSTERS","FOCUS_COORD","SELECTED_MARKER"]),
    },
    watch: {
      overlay (val) {
        val && setTimeout(() => {
          this.overlay = false
        }, 2000)
      },
    },
};
</script>

<style>
  @media screen and (max-width: 1920px) {
    .osmap{
      width: 100%;
      height: 720px;
    }
}

@media screen and (max-width: 1600px) {
    .osmap{
      width: 100%;
      height: 500px;
    }
}

@media screen and (max-width: 1280px) {
    .osmap{
      width: 100%;
      height: 450px;
    }
}

@media screen and (max-width: 1024px) {
    .osmap{
      width: 100%;
      height: 440px;
    }
}
</style>
